import { render, staticRenderFns } from "./CteComplementarDetalhes.vue?vue&type=template&id=1a62d7f6"
import script from "./CteComplementarDetalhes.vue?vue&type=script&lang=js"
export * from "./CteComplementarDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports